import { withStyles, createStyles } from "@material-ui/core"

import LogoAndText from "../../LogoAndText"

const styles = () => {
  return createStyles({
    root: {
      marginBottom: "4.375rem",
      alignItems: "flex-end",
    },
    logo: {
      marginRight: "1.5625rem",
      width: "24.4375rem",
      zIndex: 2,
    },
  })
}

export default withStyles(styles)(LogoAndText)
